// components/modals/NoFundsAlert.jsx
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Card,
  Grid,
  Avatar,
  Stack,
  Button,
} from "@mui/material";
import { Warning as WarningIcon } from "@mui/icons-material";

const NoFundsAlert = ({ open, onClose, spendingInfo, currentBalance }) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 3 }
      }}
    >
      <DialogContent sx={{ p: 4, textAlign: "center" }}>
        <Avatar sx={{ 
          bgcolor: "error.main", 
          width: 64, 
          height: 64, 
          mx: "auto", 
          mb: 2 
        }}>
          <WarningIcon sx={{ fontSize: 32 }} />
        </Avatar>
        
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Insufficient Funds Available
        </Typography>
        
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          You currently don't have sufficient funds to make payments. 
          Contact your team leader or company administrator to increase your spending power.
        </Typography>
        
        {spendingInfo && (
          <Card variant="outlined" sx={{ p: 2, mb: 3, bgcolor: "grey.50" }}>
            <Typography variant="subtitle2" fontWeight={600} gutterBottom>
              Current Status
            </Typography>
            <Grid container spacing={2} sx={{ textAlign: "left" }}>
              <Grid item xs={6}>
                <Typography variant="caption" color="text.secondary">
                  BlitzPay Balance
                </Typography>
                <Typography variant="body2" fontWeight={600}>
                  ${typeof currentBalance === 'number' ? currentBalance.toFixed(2) : (currentBalance || '0.00')}
                </Typography>
              </Grid>
              
              <Grid item xs={6}>
                <Typography variant="caption" color="text.secondary">
                  Available Spending Power
                </Typography>
                <Typography variant="body2" fontWeight={600}>
                  ${spendingInfo.total_available_funds || '0.00'}
                </Typography>
              </Grid>
              
              <Grid item xs={12}>
                <Typography variant="caption" color="text.secondary">
                  Spending Power Source
                </Typography>
                <Typography variant="body2" fontWeight={600}>
                  {spendingInfo.spending_source === 'team'
                    ? `${spendingInfo.primary_team_name || 'Team'} (Team)`
                    : `${spendingInfo.company_name || 'Company'} (Company)`}
                </Typography>
              </Grid>
            </Grid>
          </Card>
        )}
        
        <Stack spacing={2}>
          <Typography variant="body2" fontWeight={600}>
            Need more funds?
          </Typography>
          <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
            <Button 
              variant="outlined" 
              size="small"
              onClick={() => window.location.href = '/user'}
            >
              Team Settings
            </Button>
            <Button 
              variant="outlined" 
              size="small"
              onClick={() => window.location.href = 'mailto:support@useblitz.co'}
            >
              Contact Support
            </Button>
          </Box>
        </Stack>
      </DialogContent>
      
      <DialogActions sx={{ p: 3, pt: 0 }}>
        <Button onClick={onClose} variant="contained" fullWidth>
          I Understand
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NoFundsAlert;